// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"51a79d72","102":"051a4f65","199":"b64d35c7","270":"4ca23df6","544":"92d4779f","557":"dde47d84","886":"7c2496af"}[chunkId] + ".chunk.js";
};